export default class ActivationServiceError extends Error {
  public type
  public data

  constructor(message: string, type: string, data?: any) {
    super(message)
    this.name = 'ActivationServiceError'
    this.type = type
    this.data = data
  }
}
